import React, { Component } from 'react';
import { Modal, Form, FormGroup, Checkbox, ButtonToolbar, Button, ControlLabel } from 'react-bootstrap';
import Select from "react-select";

export class StopAdditionalInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStop: undefined,
        }
    }

    componentDidMount() {
        this.setState({
            selectedStop: { ...this.props.stopSelected }
        });
    }

    onHide() {
        this.setState({
            selectedStop: { ...this.props.stopSelected }
        }, () => {
            this.props.onHide();
        });
    }

    onSave() {
        const { selectedStop } = this.state;

        this.setState({
            selectedStop: { ...selectedStop }
        }, () => {
            this.props.onSaveAdditionalInfo(selectedStop)
        });
    }

    onChangeSelectValue(e, field) {
        const { selectedStop } = this.state;

        selectedStop[field] = e;

        this.setState({
            selectedStop: selectedStop
        });
    }

    onChangeValue(e, field) {
        const { selectedStop } = this.state;

        selectedStop[field] = e.target.checked;

        this.setState({
            selectedStop: selectedStop
        });
    }

    render() {
        const { selectedStop } = this.state;

        if (undefined === selectedStop) {
            return null;
        }

        const wheelchairBoardingOptions = [{ id: 0, name: "Desconhecida" }, { id: 1, name: "Possível" }, { id: 2, name: "Indisponível" }];

        return (
            <Modal show={this.props.show}>
                <Modal.Header>
                    <Modal.Title>
                        Informação Adicional da Paragem<br />
                        [{selectedStop.code}] {selectedStop.name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formWheelchairBoarding">
                            <ControlLabel>Capacidade de Embarque com Cadeira de Rodas</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Selecione uma opção"
                                onChange={(e) => this.onChangeSelectValue(null === e ? 0 : e.id, 'wheelchairBoarding')}
                                options={wheelchairBoardingOptions}
                                isMulti={false}
                                isClearable={false}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={wheelchairBoardingOptions.find(o => o.id === selectedStop.wheelchairBoarding)}
                            />
                        </FormGroup>

                        <FormGroup controlId="formSlot">
                            <Checkbox className="form-checkbox" defaultChecked={selectedStop.slot} onChange={(e) => this.onChangeValue(e, 'slot')}>
                                Slot Dedicado na Estrada
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formSignalling">
                            <Checkbox className="form-checkbox" defaultChecked={selectedStop.signalling} onChange={(e) => this.onChangeValue(e, 'signalling')}>
                                Sinalização Vertical
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formIpSignalling">
                            <Checkbox className="form-checkbox" defaultChecked={selectedStop.ipSignalling} onChange={(e) => this.onChangeValue(e, 'ipSignalling')}>
                                Sinalização da Infraestruturas de Portugal
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formShelter">
                            <Checkbox className="form-checkbox" defaultChecked={selectedStop.shelter} onChange={(e) => this.onChangeValue(e, 'shelter')}>
                                Abrigo
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formBench">
                            <Checkbox className="form-checkbox" defaultChecked={selectedStop.bench} onChange={(e) => this.onChangeValue(e, 'bench')}>
                                Assento(s)
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formNetworkMap">
                            <Checkbox className="form-checkbox" defaultChecked={selectedStop.networkMap} onChange={(e) => this.onChangeValue(e, 'networkMap')}>
                                Mapa da Rede Afixado
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formSchedule">
                            <Checkbox className="form-checkbox" defaultChecked={selectedStop.schedule} onChange={(e) => this.onChangeValue(e, 'schedule')}>
                                Horários Afixados
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formRealTimeInformation">
                            <Checkbox className="form-checkbox" defaultChecked={selectedStop.realTimeInformation} onChange={(e) => this.onChangeValue(e, 'realTimeInformation')}>
                                Informação em Tempo Real
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formTariff">
                            <Checkbox className="form-checkbox" defaultChecked={selectedStop.tariff} onChange={(e) => this.onChangeValue(e, 'tariff')}>
                                Informação de Tarifário
                            </Checkbox>
                        </FormGroup>
                    </Form>

                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}>
                            CONCLUÍDO
                        </Button>
                        <Button onClick={() => this.onHide()}>
                            CANCELAR
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
